import { Api } from "@/shared/services/api";

export interface ApiStatus {
  purchaseBlocked: boolean;
  purchaseMessage?: string;
  evbGenerationBlocked: boolean;
  evbGenerationMessage?: string;
}

export class ApiApiStatus extends Api {
  async load(): Promise<ApiStatus | undefined> {
    // kein Fehlerdialog: der Hinweis ist rein informativ
    const resp = await this.post("ApiStatusRequest", {}, false);
    return resp.successful ? resp : undefined;
  }
}
